import { convertIntoDashUSFormat } from "../../../utilities/dateUtility";
import { isPermissionPresent } from "../../../utilities/generalUtility";
import { EditIconButton } from "../../../common/components/iconButton/editIconButton";
import { DefaultColumnOptions } from "../../../hooks/useDataGrid/options";
import K from "../../../utilities/constants";

const isVisibleRender = (params) => {
  return params.data.isVisible === 0 ? "Yes" : "No";
};

const tooltipIsVisibleRender = (params) => (
  <div className="client-list-tooltip">
    {params.data.isVisible === 0 ? "Yes" : "No"}
  </div>
);

const userNameRender = (params) => {
  return params.data.userName ? params.data.userName : "N/A";
};

const tooltipUserNameRender = (params) => {
  return (
    <div className="client-list-tooltip">
      {params.data.userName ? params.data.userName : "N/A"}
    </div>
  );
};

const updatedAtRender = (params) => {
  return convertIntoDashUSFormat(params.data.updatedAt, true);
};

const jobTiersToString = ({ data }) => {
  return data.jobTiers.map((i) => i.name).join(", ");
};


const tooltipUpdatedAtRender = (params) => (
  <div className="client-list-tooltip">
    {convertIntoDashUSFormat(params.data.updatedAt, true)}
  </div>
);

const actionColumnRenderer = (roles, editRecord, editPermission) => (params) => (
  <>
    {isPermissionPresent(editPermission, roles) && (
      <EditIconButton onClick={() => editRecord(params)} />
    )}
  </>
);

const buildColumns = (roles, editRecord, editPermission) => [
  DefaultColumnOptions.Id,
  {
    headerName: "Name",
    field: "name",
    sortable: true,
    tooltipField: "name",
    sort: "asc",
  },
  {
    headerName: "Archived",
    field: "isVisible",
    sortable: true,
    tooltipField: "isVisible",
    tooltipComponent: tooltipIsVisibleRender,
    cellRenderer: isVisibleRender,
  },
  {
    headerName: "Updated By",
    field: "userName",
    sortable: true,
    tooltipField: "userName",
    cellRenderer: userNameRender,
    tooltipComponent: tooltipUserNameRender,
  },

  {
    headerName: "Updated At",
    field: "updatedAt",
    sortable: true,
    tooltipField: "updatedAt",
    cellRenderer: updatedAtRender,
    tooltipComponent: tooltipUpdatedAtRender,
  },
  {
    ...DefaultColumnOptions.Actions,
    cellRenderer: actionColumnRenderer(roles, editRecord, editPermission),
    hide: !isPermissionPresent(editPermission, roles),
  },
];

export const getColumns = (roles, editRecord) =>
  buildColumns(roles, editRecord, K.Permissions.EditLookup);

export const getClientColumns = (roles, editRecord) =>
  buildColumns(roles, editRecord, K.Permissions.EditClientLookupTables);

const tierColumn = {
  headerName: "Tier",
  field: "jobTiers",
  sortable: true,
  valueGetter: jobTiersToString,
  tooltipValueGetter: jobTiersToString,
};

export const getJobTitleColumns = (roles, editRecord) => {
  const base = getColumns(roles, editRecord);
  // Insert Tier column after Archived (index 2)
  return [...base.slice(0, 2), tierColumn, ...base.slice(2)];
};
